export const ROLE = {

    "AGENT": "AGENT",
    "ENGINEER": "ENGINEER",
    "ADMIN": "ADMIN"
};